
import { computeCollectionAmounts } from './payments';

/**
 * Filtra los pedidos que se consideran "Recaudos de Efectivo Pendientes" (Domicilios Pendientes).
 * Esta lógica es compartida entre la vista de Cartera y la de Facturación.
 * 
 * Criterios:
 * 1. Método de entrega: Domicilio, Mensajeros o indefinido (se asume domicilio por defecto si no es bodega).
 *    - Se excluyen explícitamente: 'recoge_bodega', 'recoge_en_punto', 'recoge_posterior'.
 * 2. Deuda: Debe tener un saldo pendiente real (productDue > 50).
 * 3. Estado: Debe estar en un estado logístico activo (no anulado, no entregado hace meses, etc).
 * 
 * @param {Array} orders - Lista completa de pedidos raw.
 * @returns {Array} - Lista filtrada de pedidos pendientes por recaudar.
 */
export const getPendingCollectionOrders = (orders) => {
    if (!orders || !Array.isArray(orders)) return [];

    const advancedLogisticsStatuses = new Set([
        'en_logistica',
        'en_empaque',
        'en_preparacion',
        'empacado',
        'listo_para_entrega',
        'en_reparto',
        'listo_para_recoger',
        'entregado_cliente',
        'entregado'
    ]);

    return orders.filter(o => {
        const { productDue } = computeCollectionAmounts(o);
        const status = String(o?.status || '').toLowerCase();

        // 1. Método de entrega "Calle" (Domicilio, Mensajeros, o Sin Definir)
        // Excluir explícitamente los que son de Bodega/Punto
        const isPickup = ['recoge_bodega', 'recoge_en_punto', 'recoge_posterior'].includes(o.delivery_method);
        const isDelivery = !isPickup; // Simplificación: Si no es pickup, es "calle" (o null, que tratamos como calle)

        // 2. Filtros de Estado
        const isCancelled = ['anulado', 'cancelado'].includes(status);
        const isCarteraReview = status === 'revision_cartera'; // Estos van a la tabla principal, no aquí
        const isValidStatus = advancedLogisticsStatuses.has(status);

        // 3. Saldo Pendiente
        const hasDebt = productDue > 50; // Tolerancia mínima

        return isDelivery && hasDebt && !isCancelled && !isCarteraReview && isValidStatus;
    });
};
